document.addEventListener("DOMContentLoaded", function() {
	setTimeout(function() {
		$('.img-anim').first().addClass('inview');
	}, 600);
	var currentScroll = -1;
	$(window).scroll(function(){
		newScroll = $(window).scrollTop();
		$('.img-anim').each(function(){
			var distanceScrollTop = $(this).offset().top;
			var heightElement = $(this).outerHeight();
			var heightAndOffset = heightElement+distanceScrollTop;
			var offsetVisibility = $(window).height()*0.75;
			if( currentScroll >= distanceScrollTop -offsetVisibility ){
				$(this).addClass('inview');

			}else{
				$(this).removeClass('inview');
			}
		});
		currentScroll = newScroll;
	});
});
